import React from "react";
import { Row } from "antd";
import { Company } from "interfaces/companies";
import Cover from "assets/images/BLCover.jpg";
import CompanyHeaderBox from "components/CompanyHeaderBox/CompanyHeaderBox";
import useViewport from "components/UseViewport/UseViewport";

interface Props {
  company: Company;
}

const SingleCompany: React.FC<Props> = ({ company }) => {
  const { width } = useViewport();
  const breakpoint = 950;
  if (!company) return null;
  return (
    <>
      <div style={{ height: "270px", width: "100%", overflow: "hidden", textAlign: "center" }}>
        <img
          src={company.logo_wide ?? Cover}
          width="100%"
          style={{ objectFit: "cover", height: "270px" }}
          alt={company.name}
          onError={e => {
            e.currentTarget.src = Cover; // TODO remove this on error parameter?
          }}
        />
      </div>
      <Row
        style={
          width < breakpoint
            ? { marginBottom: "20px" }
            : { transform: "translateY(-50%)", width: "75%", margin: "auto" }
        }
      >
        <CompanyHeaderBox company={company} />
      </Row>
    </>
  );
};

export default SingleCompany;
